import React from 'react';
import { useTranslation } from 'react-i18next';
import './ZodiacNav.css';

const ZODIAC_SIGNS = [
  { id: 'aries', symbol: '♈', color: '#FF6B6B' },
  { id: 'taurus', symbol: '♉', color: '#4ECDC4' },
  { id: 'gemini', symbol: '♊', color: '#45B7D1' },
  { id: 'cancer', symbol: '♋', color: '#FFA07A' },
  { id: 'leo', symbol: '♌', color: '#FFD93D' },
  { id: 'virgo', symbol: '♍', color: '#6BCF7F' },
  { id: 'libra', symbol: '♎', color: '#A8E6CF' },
  { id: 'scorpio', symbol: '♏', color: '#FF8A80' },
  { id: 'sagittarius', symbol: '♐', color: '#FFB74D' },
  { id: 'capricorn', symbol: '♑', color: '#90A4AE' },
  { id: 'aquarius', symbol: '♒', color: '#64B5F6' },
  { id: 'pisces', symbol: '♓', color: '#BA68C8' },
];

function ZodiacNav() {
  const { t } = useTranslation();

  const handleClick = (e, signId) => {
    e.preventDefault();
    const el = document.getElementById(signId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav className="zodiac-nav" aria-label={t('selectZodiac')}>
      <div className="zodiac-nav-inner">
        <h2 className="zodiac-nav-title">{t('selectZodiac')}</h2>
        <ul className="zodiac-nav-list">
          {ZODIAC_SIGNS.map((sign) => (
            <li key={sign.id}>
              <a
                href={`#${sign.id}`}
                className="zodiac-nav-link"
                style={{ '--sign-color': sign.color }}
                onClick={(e) => handleClick(e, sign.id)}
              >
                <span className="zodiac-nav-symbol">{sign.symbol}</span>
                <span className="zodiac-nav-name">{t(`zodiac.${sign.id}`)}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

export default ZodiacNav;
export { ZODIAC_SIGNS };
